module.exports = __webpack_public_path__ + "assets/img/cjwt2.491857e8.jpg";